import { AjustageConductivite } from "./ajustage-conductivite";
import { AjustageOxygene } from "./ajustage-oxygene";
import { AjustagePH } from "./ajustage-pH";
import { ControleConductivite } from "./controle-conductivite";
import { ControleConductiviteGroup } from "./controle-conductivite-groupe";
import { ControlePH } from "./controle-pH";
import { ControlePHGroup } from "./controle-pH-groupe";

export class AjustageContexte {
    Code: string
    Date: Date
    SamplerPuid: string

    /** Context repeté X fois avec un lien 1 - 1 vers AjustageOxygene */
    AjustageOxygene?: AjustageOxygene

    /** 1 a 3 Par feuille */
    AjustagePhList: AjustagePH[] = []
    ControlePhGroupeList: ControlePHGroup[] = []

    /** 1 a 3 Par feuille */
    AjustageConductiviteList: AjustageConductivite[] = []
    ControleConductiviteGroupeList: ControleConductiviteGroup[] = []
    /** Ajustage de la conductivite à 0µS/cm */
    AjustageZero: boolean;

    static mapFromJSON(json: any): AjustageContexte {
        const ms = new AjustageContexte();

        ms.Code = json.code;
        ms.Date = json.date;
        ms.SamplerPuid = json.samplerPuid;
        ms.AjustageZero = json.ajustageZero;

        if (json.ajustageOxygene) {
            ms.AjustageOxygene = AjustageOxygene.mapFromJSON(json.ajustageOxygene);
        }
        if (json.ajustagePhList) {
            ms.AjustagePhList = json.ajustagePhList.map(jsonItem => AjustagePH.mapFromJSON(jsonItem));
        }

        if (json.controlePhGroupeList) {
            ms.ControlePhGroupeList = json.controlePhGroupeList.map(jsonItem => ControlePHGroup.mapFromJSON(jsonItem));
        }

        if (json.ajustageConductiviteList) {
            ms.AjustageConductiviteList = json.ajustageConductiviteList.map(jsonItem => AjustageConductivite.mapFromJSON(jsonItem));
        }

        if (json.controleConductiviteGroupeList) {
            ms.ControleConductiviteGroupeList = json.controleConductiviteGroupeList.map(jsonItem => ControleConductiviteGroup.mapFromJSON(jsonItem));
        }

        return ms;
    }
}